import { render } from "./ficheCaisse.vue?vue&type=template&id=8869de5e&scoped=true"
import script from "./ficheCaisse.vue?vue&type=script&lang=js"
export * from "./ficheCaisse.vue?vue&type=script&lang=js"

import "./ficheCaisse.vue?vue&type=style&index=0&id=8869de5e&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8869de5e"]])

export default __exports__